import {GameFlowController} from '../../components/game-flow-controller.js';
import {MenuPanels} from '../../models/UIModel.js';

export function goToMainMenu() {
    //   if (!ClickFocusManager.GetInstance().ProposeClick(gameObject.GetComponent<Collider>())) { return; }

    const gameFlow = GameFlowController.instance;
    //if (gameFlow.canChangeMenu) {
    gameFlow.goToMainMenu();
    //}
}
